export default "__VITE_ASSET__R$86kemm__"